import sentry from 'common/helpers/analytics/sentry'

import getMakeupTypes from './getMakeupTypes'
import getSkincareTypes from './getSkincareTypes'
import getPersonalCareTypes from './getPersonalCareTypes'


const getCosmeticsTypes = (state, props, additionalFeatures = {}) => {
  const { notEmptyTypes }  = state.view.cosmeticsPage
  const { root }           = props

  const types = {
    'makeup': getMakeupTypes,
    'skincare': getSkincareTypes,
    'personalCare': getPersonalCareTypes,
  }

  if (typeof types[root] === 'function') {
    return types[root]({ ...additionalFeatures, notEmptyTypes })
  }

  sentry.captureException('Error in getCosmeticsTypes, types[root] is not a function', {
    extra: {
      types: {
        'makeup': getMakeupTypes({ ...additionalFeatures, notEmptyTypes }),
        'skincare': getSkincareTypes({ ...additionalFeatures, notEmptyTypes }),
        'personalCare': getPersonalCareTypes({ ...additionalFeatures, notEmptyTypes }),
      },
      root,
      additionalFeatures,
      notEmptyTypes,
    },
  })
}


export default getCosmeticsTypes
